var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C7.4087 0 5.88258 0.65848 4.75736 1.83058C3.63214 3.00269 3 4.5924 3 6.25V6.92625C2.16095 7.07398 1.39927 7.52655 0.850083 8.20364C0.3009 8.88074 -0.000272143 9.73859 1.84523e-07 10.625V11.875C1.84523e-07 12.7038 0.316071 13.4987 0.87868 14.0847C1.15726 14.3749 1.48797 14.6051 1.85195 14.7621C2.21593 14.9192 2.60603 15 3 15H15C15.7957 15 16.5587 14.6708 17.1213 14.0847C17.6839 13.4987 18 12.7038 18 11.875V10.625C18.0003 9.73859 17.6991 8.88074 17.1499 8.20364C16.6007 7.52655 15.8391 7.07398 15 6.92625V6.25C15 4.5924 14.3679 3.00269 13.2426 1.83058C12.1174 0.65848 10.5913 0 9 0ZM6 6.875H8.4V11.25H9.6V6.875H12V5.625H6V6.875Z",
    fill: "#1C801C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyword);
export default __webpack_public_path__ + "static/media/keyword.b71033e4d327c5c7934e92a9988b7cee.svg";
export { ForwardRef as ReactComponent };